var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMediaDt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.94 40.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.53,7.94v20.41c-.32.01-12.16.34-12-13.28v-3.15h7.25v-3.98h-18.33v3.98h7.3v3.15s.12,12.52-8.18,13.41v4.06s7.57-.27,9.59-8.44h1.02s2.76,8.25,13.35,8.39v7.59h3.98V7.94h-3.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.58,19.51h14.33v3.25h-15.63c-4.87,0-4.66-3.75-4.66-4v-6.7l3.84-4.12h14.57v3.22h-14.54v2.73h10.91v2.94h-10.89v.39c0,.16-.19,2.28,2.06,2.28h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.8,7.93v5.91h-4.71v2.96h4.71v5.95h3.89V7.93h-3.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.97,36.87c-2.24,0-2.15-1.87-2.15-2.02v-.58h21.84v-9.02h-25.83v3.27h21.87v2.76h-21.87v4.71c0,4.51,4.62,4.13,4.62,4.13h21.78v-3.25h-20.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.87,23.16V7.92h-3.89v20.52h-16.28c-2.81,0-2.83-2.05-2.83-2.97v-3.37h13.44v-4.01h-13.44v-6.16h14.3v-4h-14.32l-3.95,4.24h-.01v15.48c0,5.31,4.4,5,4.88,5h18.21v7.45h3.89v-12.93h4.05v-4h-4.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.51,7.81c-5.29,0-9.59,3.75-9.59,8.38s4.3,8.37,9.59,8.37,9.58-3.75,9.58-8.37-4.29-8.38-9.58-8.38ZM137.51,21.28c-2.91,0-5.26-2.28-5.26-5.09s2.35-5.09,5.26-5.09,5.26,2.28,5.26,5.09-2.36,5.09-5.26,5.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.13,7.87h-3.93v16.84h3.93V7.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.13,40.05h20.99v-12.74h-26.14v8.26s-.44,4.49,5.15,4.49h0ZM136.66,35.94c-2.82,0-2.69-2.51-2.69-2.72v-1.88h18.22v4.6h-15.54,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.06,17.33s-2.45-2.21-2.72-8.12v-1.45h-3.9v1.45c-.27,5.91-2.6,8.08-2.6,8.08-2.37,3-8.99,3.28-8.99,3.28v3.92c11.14-.66,13.6-5.52,13.6-5.52,0,0,2.45,4.86,13.53,5.52v-3.92s-6.55-.24-8.92-3.24Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.94,33.55h-28.95v4.19h28.95v-4.19Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.11,7.94v20.65H7c-.32,0-3.09.09-3.09-2.74v-13.91h14.39l.02-3.99H3.62l-3.62,3.72v15.49c0,.73-.3,5.47,4.74,5.47h18.37v7.47h3.94V7.94h-3.94Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.05-.17h-3.94V3.93h3.94V-.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMediaDt);
export default __webpack_public_path__ + "static/media/ic_media_dt.6497f69d10d531cadf2301dad6e98916.svg";
export { ForwardRef as ReactComponent };